import { ConfigExtensionFactory } from '@blocksuite/std';
import type { TemplateResult } from 'lit';

import type { WorkflowStepBlockModel } from '../schemas/workflow-step-model.js';

export type WorkflowStepBlockConfig = {
  /**
   * The card of a step. The workflow editor draws it, since run state,
   * checks and the presence of others live there, not in the document.
   */
  renderCard: (step: WorkflowStepBlockModel) => TemplateResult;
  /**
   * Whether the card fills the box the step was laid out in, as a loop's
   * frame does; any other card is as high as its content.
   */
  fillsBox: (step: WorkflowStepBlockModel) => boolean;
  /**
   * The card of a step measured `height`. The workflow editor gives the step
   * that height and makes room for it around (the layout or the steps below);
   * the measure is no edit of its own and stays out of undo.
   */
  cardMeasured: (step: WorkflowStepBlockModel, height: number) => void;
  /** The user dragged the step to another place. */
  moved: (step: WorkflowStepBlockModel) => void;
};

export const WorkflowStepBlockConfigExtension =
  ConfigExtensionFactory<WorkflowStepBlockConfig>('affine:workflow-step');
